module.exports = __webpack_public_path__ + "static/scale-model-of-the-speed-art-museum-in-louisville-kentucky-7345a56350598b3cf777696cac933305.png";